import { ServerOption } from '@entities/server/model/server.types'

export const defaultServers: ServerOption[] = [
  { value: 'Europe', label: 'Europe' },
  { value: 'America', label: 'America' },
  { value: 'Asia', label: 'Asia' },
]

export const nikkeServers: ServerOption[] = [
  { value: 'Korea', label: 'Korea' },
  { value: 'Japan', label: 'Japan' },
  { value: 'Global', label: 'Global' },
  { value: 'NA', label: 'NA' },
  { value: 'SEA', label: 'SEA' },
]

export const harryPotterServers: ServerOption[] = [
  { value: 'Sphinx', label: 'Sphinx' },
  { value: 'Rougarou', label: 'Rougarou' },
  { value: 'Erumpent', label: 'Erumpent' },
  { value: 'Ashwinder', label: 'Ashwinder' },
  { value: 'Thunderbird', label: 'Thunderbird' },
  { value: '验客', label: '验客' },
  { value: '不死鸟', label: '不死鸟' },
  { value: 'ユニコーン', label: 'ユニコーン' },
  { value: '나플러', label: '나플러' },
]

export const lifeAfterServers: ServerOption[] = [
  { value: 'CrystalthornSea', label: 'CrystalthornSea' },
  { value: 'EasySurvival', label: 'EasySurvival' },
  { value: 'SimpleSurvival', label: 'SimpleSurvival' },
  { value: 'LabyrinthSea', label: 'LabyrinthSea' },
  { value: 'HopeWall', label: 'HopeWall' },
  { value: 'Twinislands', label: 'Twinislands' },
  { value: 'ChaosCity', label: 'ChaosCity' },
  { value: 'MileStone', label: 'MileStone' },
  { value: 'LevinCity', label: 'LevinCity' },
  { value: 'Santopany', label: 'Santopany' },
  { value: 'SnowHighlands', label: 'SnowHighlands' },
  { value: 'CharlesTown', label: 'CharlesTown' },
  { value: 'NancyCity', label: 'NancyCity' },
  { value: 'CrystalthornSea', label: 'CrystalthornSea' },
  { value: 'IronStride', label: 'IronStride' },
  { value: 'ChaosOutpost', label: 'ChaosOutpost' },
  { value: 'NewLand', label: 'NewLand' },
  { value: 'Obelisk', label: 'Obelisk' },
  { value: 'RedwoodTown', label: 'RedwoodTown' },
  { value: 'MouthSwamp', label: 'MouthSwamp' },
  { value: 'SandCastle', label: 'SandCastle' },
  { value: 'MiskaTown', label: 'MiskaTown' },
]

export const onceHumanServers = [
  { value: 'Europe', label: 'Europe' },
  { value: 'North America', label: 'North America' },
  { value: 'South America', label: 'South America' },
  { value: 'Southeast Asia Server', label: 'Southeast Asia Server' },
  { value: 'HK/Macao/Taiwan', label: 'HK/Macao/Taiwan' },
  { value: 'Korea Server', label: 'Korea Server' },
  { value: 'Japan Server', label: 'Japan Server' },
]
